// @flow
import { BLOG, BLOG_CATEGORY } from '@routes';
import { nextRoutes } from '@i18n';

import type { Query, CanonicalConditions } from './types';

// return url without pageNumber=1
const getUrlForFirstPage = (query: Query, pathname: string): string => {
  const isFirstPage = query?.pageNumber === '1';
  const pathnameWithoutPageNumber = pathname && nextRoutes.match(pathname)?.parsedUrl?.pathname;

  return isFirstPage ? pathnameWithoutPageNumber : pathname;
};

// can add conditions for different routes
// for multiple conditions in the future, lodash compose can be used
export const canonicalConditions: CanonicalConditions = {
  [BLOG]: getUrlForFirstPage,
  [BLOG_CATEGORY]: getUrlForFirstPage
};
